import {Action} from "redux";
import {
    GetAllContractListByClientRequest,
} from "../request/contract_request";

import {
    GetAllContractListByClientResponse,
} from "../response/contract_response";

export enum ClientContractListActionType {

    REQUEST_GET_ALL_CONTRACT_LIST_BY_CLIENT = "CLIENT_CONTRACT_LIST_REQUEST_GET_ALL_BY_CLIENT",
    CALLBACK_GET_ALL_CONTRACT_LIST_BY_CLIENT = "CLIENT_CONTRACT_LIST_CALLBACK_GET_ALL_BY_CLIENT",

}

export interface IRequestGetAllContractListByClientAction extends Action {
    type: ClientContractListActionType.REQUEST_GET_ALL_CONTRACT_LIST_BY_CLIENT;
    item: GetAllContractListByClientRequest;
}

export interface ICallbackGetAllContractListByClientAction extends Action {
    type: ClientContractListActionType.CALLBACK_GET_ALL_CONTRACT_LIST_BY_CLIENT;
    isSuccess: boolean;
    item?: GetAllContractListByClientResponse;
    error?: any;
}

export type ClientContractListAction =
    IRequestGetAllContractListByClientAction |
    ICallbackGetAllContractListByClientAction;

export interface IClientContractListActionCreator {

    requestGetAllByClientContractAction(
        item: GetAllContractListByClientRequest,
    ): IRequestGetAllContractListByClientAction;

    callbackGetAllByClientContractAction(
        isSuccess: boolean,
        item?: GetAllContractListByClientResponse,
        error?: any,
    ): ICallbackGetAllContractListByClientAction;

}

class ActionCreator implements IClientContractListActionCreator {

    public requestGetAllByClientContractAction = (
        item: GetAllContractListByClientRequest,
    ): IRequestGetAllContractListByClientAction => {
        return {
            type: ClientContractListActionType.REQUEST_GET_ALL_CONTRACT_LIST_BY_CLIENT,
            item,
        };
    };

    public callbackGetAllByClientContractAction = (
        isSuccess: boolean,
        item?: GetAllContractListByClientResponse,
        error?: any,
    ): ICallbackGetAllContractListByClientAction => {
        return {
            type: ClientContractListActionType.CALLBACK_GET_ALL_CONTRACT_LIST_BY_CLIENT,
            isSuccess,
            item,
            error,
        };
    };

}

export const createClientContractListActionCreator = (): IClientContractListActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_contracts_action.ts